// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2275":"5b75b5fef47c1cf7","7617":"b45cc612acecd7c8"}[chunkId] + ".css";
};